import APIURL from "../axios";
import { useQuery } from "react-query";

const AboutUsAPI = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}/about`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};

export const ShowAboutUs = (uuid, lang) => {
  return useQuery(`about-us-${lang}`, () => AboutUsAPI(uuid, lang));
};
